import React, { Component } from 'react'
import { connect } from 'react-redux'

import { show } from 'client/shared/reducers/fake-page-reducer'

import StoreLinks from 'client/shared/blocks/store-links'

import { Dispatch } from 'shared/types/redux'

type Props = {
  dispatch: Dispatch
}

class StoreLinksBox extends Component<Props> {
  render() {
    const { dispatch } = this.props

    return (
      <StoreLinks show={() => dispatch(show('getTheApp', { type: 'book' }))} />
    )
  }
}

export default connect()(StoreLinksBox)
